(function ($) {
  "use strict";
  jQuery(document).ready(function(){
    var windows = $(window);
    var sticky = $('.header-sticky');
    windows.on('scroll', function() {
      var scroll = windows.scrollTop();
      if (scroll < 100) {
        sticky.removeClass('is-sticky');
      }else{
        sticky.addClass('is-sticky');
      }
    });
    $("button.navbar-toggler").on('click', function() {
      $(".menu-drawer").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    });
    $(".menu-drawer-close").on('click', function() {
      $(".menu-drawer").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $(".mm-fullscreen-bg").click(function(){
      $(".menu-drawer").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".filter-sidebar").closest(".shopify-section").css({"transform":"","will-change":""});
      $("body").removeClass("hidden");
    });
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $(".filter-sidebar").closest(".shopify-section").css({"transform":"none","will-change":"auto"});
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $(".filter-sidebar").closest(".shopify-section").css({"transform":"","will-change":""});
    });
    $('.full-view, .zoom').on('click', function() {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type:'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        }
      }).magnificPopup('open');
    });
    $(window).scroll(function(){
      if ($(this).scrollTop() > 1000) {
        $('#top').fadeIn();
      } else {
        $('#top').fadeOut();
      }
    });
    $('#top').click(function(){
      $("html, body").animate({ scrollTop: 0 }, 100);
      return false;
    });
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });
    $(document).on("click", ".menu-arrow", function(e) {
      var menu_link = $(this).closest("li"),
          main_menu = menu_link.find(".menu-dropdown").eq(0);
          if(menu_link.hasClass("open")){
            menu_link.removeClass("open");
            main_menu.removeClass("open");
          }else{
            main_menu.addClass("open");
            menu_link.addClass("open");
          }
       e.stopPropagation();
       e.preventDefault();
    });
    $(document).on("click", ".menu-arrow-sub", function(e) {
      var menu_link = $(this).closest("li"),
          main_menu = menu_link.find(".supmenu-dropdown").eq(0);
          if(menu_link.hasClass("open")){
            menu_link.removeClass("open");
            main_menu.removeClass("open");
          }else{
            main_menu.addClass("open");
            menu_link.addClass("open");
          }
       e.stopPropagation();
       e.preventDefault();
    });
    $(document).on("click", ".back-menu", function(e) {
      var back_menu = $(this).closest(".menu-dropdown");
        back_menu.removeClass('open');
        back_menu.closest('.menu-link').removeClass('open');
       e.stopPropagation();
       e.preventDefault();
    });
    $(document).on("click", ".back-menu-sub", function(e) {
      var back_menu = $(this).closest(".supmenu-dropdown");
        back_menu.removeClass('open');
        back_menu.closest('.singlemenu-li').removeClass('open');
       e.stopPropagation();
       e.preventDefault();
    });

    // Product description tab -> accordion on mobile
    var $descTab = $('.product-description-tab');
    if ($descTab.length) {
      var $tabNav = $descTab.find('.tab ul.nav-tabs');
      var mobileTabQuery = window.matchMedia('(max-width: 767px)');

      var moveIntoAccordion = function() {
        $tabNav.find('> li').each(function() {
          var $li = $(this);
          var $a = $li.find('> a');
          var $pane = $descTab.find($a.attr('href'));
          if ($pane.length && $pane.parent().is('.description-review-text')) {
            $pane.data('homeParent', $pane.parent());
            $li.append($pane);
          }
        });
        $tabNav.find('> li').removeClass('open');
        $tabNav.find('.tab-pane').css('display', 'none');
        var $activeLi = $tabNav.find('> li > a.active').closest('li');
        $activeLi.addClass('open').find('.tab-pane').css('display', 'block');
        $descTab.addClass('mobile-accordion-mode');
      };

      var restoreTabs = function() {
        var $openLi = $tabNav.find('> li.open');
        if ($openLi.length) {
          $tabNav.find('> li > a').removeClass('active');
          $openLi.find('> a').addClass('active');
        }
        $tabNav.find('.tab-pane').each(function() {
          var $pane = $(this);
          var $home = $pane.data('homeParent');
          $pane.toggleClass('active', $pane.closest('li').hasClass('open'));
          if ($home && $home.length) {
            $pane.css('display', '').appendTo($home);
          }
        });
        $tabNav.find('> li').removeClass('open');
        $descTab.removeClass('mobile-accordion-mode');
      };

      var handleViewportChange = function(query) {
        if (query.matches) {
          moveIntoAccordion();
        } else {
          restoreTabs();
        }
      };

      handleViewportChange(mobileTabQuery);
      if (mobileTabQuery.addEventListener) {
        mobileTabQuery.addEventListener('change', handleViewportChange);
      } else {
        mobileTabQuery.addListener(handleViewportChange);
      }

      $descTab.on('click', '.tab ul.nav-tabs > li > a', function(e) {
        if (!mobileTabQuery.matches) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var $a = $(this);
        var $li = $a.closest('li');
        var isOpen = $li.hasClass('open');
        $tabNav.find('> li').removeClass('open').find('> a').removeClass('active');
        $tabNav.find('.tab-pane').css('display', 'none');
        if (!isOpen) {
          $li.addClass('open');
          $a.addClass('active');
          $li.find('.tab-pane').css('display', 'block');
        }
      });
    }

    // Global Scroll Reveal (Intersection Observer)
    if ('IntersectionObserver' in window) {
      var revealSections = document.querySelectorAll('main .shopify-section, footer .shopify-section');
      
      var sectionObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.05,
        rootMargin: "0px 0px -50px 0px"
      });

      revealSections.forEach(function(section) {
        var isHeader = section.closest('header') || section.closest('.header-area') || section.id.indexOf('header') !== -1;
        if (!isHeader && !(window.Shopify && window.Shopify.designMode)) {
          section.classList.add('shopify-section-reveal');
          sectionObserver.observe(section);
        } else {
          section.classList.add('is-visible');
        }
      });

      // Handle section addition in Shopify customizer/editor dynamically
      document.addEventListener('shopify:section:load', function(event) {
        event.target.classList.add('is-visible');
      });
    } else {
      var revealSections = document.querySelectorAll('main .shopify-section, footer .shopify-section');
      revealSections.forEach(function(section) {
        section.classList.add('is-visible');
      });
    }
  });
})(jQuery);